<template>
	<div class="mLoginCo">
		<div class="iconImgBox">
			<img class="iconImg" src="../../assets/loginIcon.png" alt="">
		</div>
		<div class="iconTitle">兰树邮箱</div>
		<div class="loginBtn">马上登录邮箱</div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				
			}
		}
	}
</script>

<style scoped>
	.mLoginCo{
		display:flex;
		flex-direction: column;
		align-items: center;
	}
	
	.iconImg{
		width: 100%;
	}
	
	.iconImgBox{
		width: 20%;
		margin-top: 40%;
	}
	
	.iconTitle{
		color: #999999;
		font-size: 0.8rem;
	}
	
	.loginBtn{
		width: 70%;
		background: #007AFF;
		border-radius: 2rem;
		line-height: 35px;
		color: #FFFFFF;
		text-align: center;
		font-size: 0.8rem;
		opacity: 0.9;
		margin-top: 30%;
	}
	
</style>



// WEBPACK FOOTER //
// src/components/mComponents/mLogin.vue